import { defineStore } from 'pinia';
import { INotification } from '@/types/notificationTypes';

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    notifications: [] as INotification[],
  }),
  persist: true,
  actions: {
    addNotification(notification: INotification) {
      if (this.notifications.filter((n) => n.message === notification.message).length > 0) {
        return;
      }
      this.notifications.push(notification);
    },
    removeNotification(notification: INotification) {
      this.notifications = this.notifications.filter((n) => n !== notification);
    },
  },
});
